<template>
	<div>
		<canvas ref="tradeChart"></canvas>
	</div>
</template>

<script>
import { Chart, LineController, LineElement, PointElement, LinearScale, Title, CategoryScale, TimeScale } from 'chart.js';
import 'chartjs-adapter-date-fns';

Chart.register(LineController, LineElement, PointElement, LinearScale, Title, CategoryScale, TimeScale);

export default {
	name: 'TradesByDateChart',
	props: {
		tradesByDate: {
			type: Array,
			required: true
		}
	},
	data() {
		return {
			chart: null
		};
	},
	watch: {
		tradesByDate: {
			handler(newData) {
				if (!newData || newData.length === 0) {
					if (this.chart) {
						this.chart.destroy();
						this.chart = null;
					}
					return;
				}
				this.$nextTick(() => {
					this.destroyChart();
					this.renderChart();
				});
			},
			deep: true,
			immediate: true
		}
	},
	mounted() {
		if (this.tradesByDate && this.tradesByDate.length > 0) {
			this.$nextTick(() => {
				this.renderChart();
			});
		}
	},
	beforeUnmount() {
		this.destroyChart();
	},
	methods: {
		renderChart() {
			const canvas = this.$refs.tradeChart;
			if (!canvas) {
				console.warn('Canvas element is not available.');
				return;
			}

			const ctx = canvas.getContext('2d');
			if (!ctx) {
				console.warn('Unable to get canvas 2D context.');
				return;
			}

			this.chart = new Chart(ctx, {
				type: 'line',
				data: {
					labels: this.tradesByDate.map(data => data.tradeDate),
					datasets: [{
						label: 'Number of Trades',
						data: this.tradesByDate.map(data => data.tradeCount),
						borderColor: 'rgba(75, 192, 192, 1)',
						backgroundColor: 'rgba(75, 192, 192, 0.2)',
						borderWidth: 2,
						tension: 0.3
					}]
				},
				options: {
					responsive: true,
					maintainAspectRatio: false,
					scales: {
						x: {
							type: 'time',
							time: {
								unit: 'day',
								tooltipFormat: 'PP'
							},
							title: {
								display: true,
								text: 'Date'
							}
						},
						y: {
							beginAtZero: true,
							title: {
								display: true,
								text: 'Trades Count'
							}
						}
					},
					plugins: {
						legend: {
							display: true
						},
						tooltip: {
							mode: 'index',
							intersect: false
						}
					}
				}
			});
		},
		destroyChart() {
			if (this.chart) {
				this.chart.destroy();
				this.chart = null;
			}
		}
	}
};
</script>

<style scoped>
canvas {
	max-width: 100%;
	height: 400px;
}
</style>
